<template>
  <MyManage>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="客流分析" name="customerFlow" v-if="checkPermission(['bee:member:customerFlow:customerFlowStatistics'])">
        <CustomerFlow v-if="activeName==='customerFlow'"></CustomerFlow>
      </el-tab-pane>
    </el-tabs>
  </MyManage>
</template>

<script>
  import MyManage from '@/components/MyManage'
  import CustomerFlow from '@/module/dataCenter/page/customerAnalyse/customerFlow.vue'

  export default {
    name: 'manage',
    components: {
      MyManage,
      CustomerFlow
    },
    data() {
      return {
        activeName: 'customerFlow',
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {
      handleClick(tab, event) {
      }
    }
  }
</script>

<style>
  .el-dialog__header {
    text-align: center;
  }

  #manage .el-switch.is-disabled .el-switch__core, #manage .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/customerManager.vue